import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faBars,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import logo from "../logo.png";
import "../assets/css/MobileHeader.css";

const SiteHeader = ({ activePage }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="modern_nav shell">
      <Link to="/" className="brand_mark" onClick={closeMenu}>
        <div className="brand_lockup">
          <img className="brand_logo" src={logo} alt="Staffing Mart" />
        </div>
      </Link>
      <nav
        className={`modern_nav_links ${menuOpen ? "is_open" : ""}`}
        aria-label="Main navigation"
      >
        <Link
          className={activePage === "services" ? "active" : ""}
          to="/services"
          onClick={closeMenu}
        >
          Services
        </Link>
        <Link
          className={activePage === "contact" ? "active" : ""}
          to="/contact"
          onClick={closeMenu}
        >
          Contact
        </Link>
      </nav>
      <Link to="/contact" className="nav_cta">
        Start a conversation <FontAwesomeIcon icon={faArrowRight} />
      </Link>
      <button
        type="button"
        className="mobile_menu_button"
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((open) => !open)}
      >
        <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} />
      </button>
    </header>
  );
};

export default SiteHeader;
